import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "warning-icon" }
const _hoisted_2 = { class: "warning-content" }
const _hoisted_3 = { key: 0 }

import { IonIcon } from '@ionic/vue';
import { warningOutline, alertCircle } from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'Warning',
  props: {
    title: {},
    body: {},
    orange: { type: Boolean },
    red: { type: Boolean },
    coral: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["warning", { 'orange': __props.orange, 'red': __props.red, 'coral': __props.coral }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.coral)
        ? (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 0,
            src: _unref(alertCircle),
            size: "large"
          }, null, 8, ["src"]))
        : (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 1,
            src: _unref(warningOutline),
            size: "large"
          }, null, 8, ["src"]))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (__props.title)
        ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(__props.title), 1))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(__props.body), 1)
    ])
  ], 2))
}
}

})